import { Component, OnInit, ChangeDetectionStrategy, Input, EventEmitter, Output, Inject, LOCALE_ID } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PurchaseService } from '@schoolbelle/api/purchase';
import { Subscription } from 'rxjs';
import { v4 as uuid } from 'uuid';

export class ProductParams {
  productId:number
  amount?:number
  quantity?:number
};

@Component({
  selector: 'app-select-abstract',
  template: '',
})
export class SelectAbstractComponent implements OnInit {
  @Input() form:FormGroup;
  @Input() required:boolean = false;
  @Input() products:ProductParams[] = [];
  @Output() productsChange = new EventEmitter<ProductParams[]>();
  
  uuid:string;
  indexCtrl:FormControl = new FormControl(null);

  public paymentCurrency:FormControl;
  public taxRate:FormControl;



  protected subscriptions = new Subscription();
  constructor (
    protected purchase:PurchaseService,
  ) {
  }
  ngOnInit(): void {
    this.uuid = uuid();
    this.indexCtrl.valueChanges.subscribe((index:number)=>this.onUpdate(index));
    if (this.required !== false) {
      this.indexCtrl.setValidators([Validators.required]);
    }
    this.form.setControl(this.uuid, this.indexCtrl);
    
    this.paymentCurrency = this.form.get('paymentCurrency') as FormControl;
    this.taxRate = this.form.get('taxRate') as FormControl;
  }
  onUpdate (index:number):void {

  }

  ngOnDestroy () {
    this.form.removeControl(this.uuid);
    this.subscriptions.unsubscribe();
  }


}
